import {Injectable} from '@angular/core';
import {Components} from "@gen-nexus-registry/grid-lib";
import GridToast = Components.GridToast;

export interface Message {
  text: string,
  type: GridToast["type"]
  id?: number
}

@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  messages: Message[] = [];

  addMessage(message: Message) {
    this.clearAll();
    this.messages.push(message);
  }

  addMessages(messages: Message[]) {
    this.clearAll();
    this.messages = messages;
  }

  clearAll() {
    this.messages = [];
  }

  // TODO: al momento non usare perché GRID non ha implementato la onClose nel grid-toast
  clear(message: Message) {
    this.messages = this.messages.filter(m => m.id !== message.id);
  }
}




